import { ErrorHandler, Injectable } from '@angular/core';
import { throttle } from '@sama/micro-dash';
import { MessagingService } from './messaging.service';
import { RollbarService } from './rollbar.service';

const errorMessageCooldown = 30_000; // 30 seconds

@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  private throttledMessageFns: { [message: string]: () => void } = {};

  constructor(
    private messaging: MessagingService,
    private rollbarService: RollbarService,
  ) {}

  handleError(error: any) {
    console.error(error);
    this.getMessageFn(error)();
  }

  /**
   * Error message can come from (among other sources) errors that occur in a
   * template expression. Those can happen many times in rapid succession, and
   * can continue happening with every change detection cycle. So throttle how
   * often they are sent to rollbar and displayed in the red banner at the top
   * of the page.
   */
  private getMessageFn(error: any) {
    const name = error?.name;
    const message = (error && error.message) || error;
    let messageFn = this.throttledMessageFns[message];
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    if (messageFn) {
      return messageFn;
    }

    messageFn = throttle(
      () => {
        if (name === 'UserError') {
          this.messaging.error(message);
        } else {
          this.sendMessage(error);
        }
      },
      errorMessageCooldown,
      { trailing: false },
    );
    this.throttledMessageFns[message] = messageFn;
    return messageFn;
  }

  private sendMessage(error: any) {
    this.rollbarService.error(error);
    this.messaging.showGenericError();
  }
}
